import React from 'react';

import { useBankFeedRouteContext } from 'pages/company/BankFeedRoute/context';
import BankFilterToolbar from 'pages/company/BankFeedRoute/components/FilterToolbar/BankFilterToolbar';
import CardFilterToolbar from 'pages/company/BankFeedRoute/components/FilterToolbar/CardFilterToolbar';

// Per-tab toolbar dispatcher: the Bank tab uses a multi-select account filter, the Credit Card
// tab a single-value one (DA-19483). Splitting per tab keeps future divergences (e.g. the CC
// async date filter) local to one composition instead of branching inside shared controls.
const FilterToolbar: React.FC = () => {
  const { accountType } = useBankFeedRouteContext();
  return accountType === 'CARD' ? <CardFilterToolbar /> : <BankFilterToolbar />;
};

export default FilterToolbar;
